import React from "react";
import { HiXMark, HiUser, HiEnvelope, HiCreditCard } from "react-icons/hi2";
import "../styles/Modals.css";

const ProfileModal = ({ user, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content profile-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          <HiXMark />
        </button>

        <div className="profile-header">
          <div className="profile-avatar">
            <HiUser />
          </div>
          <h2>{user?.fullName}</h2>
          <p className="profile-subtitle">{user?.email}</p>
        </div>

        <div className="profile-details">
          <div className="detail-group">
            <h3>Personal Information</h3>

            <div className="detail-item">
              <div className="detail-icon">
                <HiUser />
              </div>
              <div className="detail-content">
                <label>Full Name</label>
                <p>{user?.fullName}</p>
              </div>
            </div>

            <div className="detail-item">
              <div className="detail-icon">
                <HiEnvelope />
              </div>
              <div className="detail-content">
                <label>Email Address</label>
                <p className="text-truncate">{user?.email}</p>
              </div>
            </div>
          </div>

          <div className="detail-group">
            <h3>Account Information</h3>

            <div className="detail-item">
              <div className="detail-icon">
                <HiCreditCard />
              </div>
              <div className="detail-content">
                <label>Account Number</label>
                <p className="monospace">{user?.accountNumber}</p>
              </div>
            </div>

            <div className="detail-item">
              <div className="detail-icon">
                <HiUser />
              </div>
              <div className="detail-content">
                <label>Account Type</label>
                <p>Private Bank Account</p>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
